export type EmailCode = {
    email: string,
    code: string,
    expires: number,
    created: number,
}

export const authorized_admins = ['forrestmilner@gmail.com', 'susanmilner1969@gmail.com', 'milner.christopher@gmail.com', 'cmilner@oakleaf.com', 'cmilner@yahoo.com']

export type Attendee = {
    lastName: string,
    firstName: string,
    ageOnApril24: "0" | "1" | "2" | "3" | "4" | "5" | "6" | "7" | "8" | "9" | "10" | "11" | "12" | "13" | "14" | "15" | "16" | "17" | "18 or over",
    registeredForRE: boolean,

    responsibleAdult: string,

    vegetarian: boolean,
    vegan: boolean,
    glutenFree: boolean,
    dairyFree: boolean
}

export type Payment = {
    amount: number,
    date: number, // ms since epoch
    event_id: string,
}

export const bunkTypes = {
    "bunk-family": "Bunk Room for Families with Children/Youth",
    "bunk-all": "Bunk Room for Adults (Gender-Inclusive)",
    "bunk-women": "Bunk Room for Women",
    "bunk-men": "Bunk Room for Men",
    "bunk-young": "Bunk Room for Young Souls (18-35~ish)",
    "tent": "Outside Tent Camping",
    "day-tripper": "Day-Tripper (Saturday Lunch, Saturday Dinner only)",
    "off-site-all-meals": "Staying off-site (all meals)",
}

export type Registration = {
    email: string,
    lastName: string,
    firstName: string,
    phoneNumber: string,
    preferredContactMethod: string,

    attendees: Attendee[],
    additionalDietaryNeeds: string,

    sleepingArrangementChoice: keyof typeof bunkTypes,
    cabinSharing: string,
    sleepingArrangementsComments: string,

    abilityToPay: "" | "I can pay more than my fair share" | "I can pay my fair share" | "I can pay a reduced rate" | "Please waive my registration fees" | "Specialized Fees",
    waiverReason: string,
    donationAmount: number,

    registrationComments: string,
    rideSharing: string,
    liabilityWaiverAccepted: boolean,
    liabilityWaiverAcceptedBy: string
}

export type Payments = {
    email: string,
    confirmed?: boolean,  // Confirmed indicates the server has accepted the registration. A confirmed registration cannot be updated.
    waitlist?: boolean,  //
    payments: Payment[]
}


export type ServerConfig = {
    waitlistOnly: boolean,
    noNewRegistrations: boolean,
}

export type AdminSummary = {
    registrationCount: number,
    regs: (Partial<Registration> & {count: number, confirmed: boolean, waitlist: boolean})[];
    registrations: {
        max: number,
        completed: number,
        inProgress: number,
    }
    owedRefund: string[];
}

export function validateRegistration(registration: Registration): string | undefined {
    if (!registration) {
        return 'No registration found.'
    }
    if (!registration.attendees?.length) {
        return 'No attendees. You must register at least one attendee.'
    }
    if (!registration.liabilityWaiverAccepted) {
        return 'You must accept the liability waiver. (Part 5)'
    }
    if (!registration.liabilityWaiverAcceptedBy) {
        return 'You must enter your name as the person who accepted the liability waiver. (Part 5)'
    }
    if (!registration.sleepingArrangementChoice) {
        return 'You must select a sleeping arrangement. (Part 3)'
    }
    if (!registration.firstName) {
        return 'You must enter your first name. (Part 1)'
    }
    if (!registration.lastName) {
        return 'You must enter your last name. (Part 1)'
    }
    if (!registration.phoneNumber) {
        return 'You must enter your phone number. (Part 1)'
    }
}